// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xn_a bhs_vp bhs_vh bhs_xe bhs_rg bhs_tr bhs_qx"};